<dx-select-box [value]="profileItem"
               (valueChange)="valueChange.emit($event)"
               [dataSource]="profileItemValues"
               [showClearButton]="true"
               [displayExpr]="getDisplayName"
               placeholder="Select profile item value..."> </dx-select-box>
